export default __webpack_public_path__ + "static/media/foundation-image.1c693929.svg";